import { type SecondaryCategory } from '@webapp/core/entities/internal/SecondaryCategory'

export const stringifySecondaryCategory = (
  secondaryCategory: SecondaryCategory
) => {
  const primaryCategory = secondaryCategory.primaryCategory
  if (!primaryCategory) {
    return secondaryCategory.name
  }
  return `${primaryCategory.name} - ${secondaryCategory.name}`
}
